import { CheckoutState } from '../../state';
import {
    isChromeMobileWebView,
    isEventbriteTLDInDevOrQAEnv,
} from '../../utils/browser';
import { isEventbriteTLD } from '../app';
import { areSyncExpressCheckoutEligibleCommonRulesMet } from '../expressCheckoutConditions';

export const areSyncExpressPaypalEligibleRulesMet = (state: CheckoutState) =>
    areSyncExpressCheckoutEligibleCommonRulesMet(state) &&
    (isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv()) &&
    !isChromeMobileWebView();
